// @flow

import mobx, { observable, computed } from 'mobx';
import HttpBackend from '../Services/HttpBackend'

export class SettingsEntry {
  @observable id: number;
  @observable settings_key: string;
  @observable value: any;
  
  constructor (json?: any) {
    if (json) {
      Object.assign(this, json);
      try {
        this.value = JSON.parse(this.value);
      } catch (err) {
      
      }
    }
  }
  
  @computed get toJSON(): any {
    return {
      id: this.id,
      settings_key: this.settings_key,
      value: this.value ? JSON.stringify(this.value) : null
    };
  }
  
  // @computed get valueJson(): any {
  //   try {
  //     return JSON.parse(this.value);
  //   } catch (err) {
  //
  //   }
  //   return null;
  // }
}

export default class Settings {
  
  @observable settings: Map<string, SettingsEntry> = new Map();
  
  constructor(json?: any) {
    if (json) {
      this.settings = json.settings;
    }
  }

  static async get(): Promise<Settings> {
    const res = await HttpBackend.get('/api/settings/internal');
    if (res.ok) {
      const mapData = [];
      for (const entry of res.data) {
        mapData.push([entry.settings_key, new SettingsEntry(entry)]);
      }
      return new Settings({ settings: new Map(mapData) });
    }
    return new Settings();
  }
}


// WEBPACK FOOTER //
// ./src/App/Model/Settings.js